import { create } from 'zustand'

type State = {
  errors: Record<string, Record<string, string>>
  recordResult: (companyId: string, logs?: string) => void
  clearErrors: (companyId: string, driverIds: string[]) => void
}

// ponytail: last export errors live only in this session; use server history if they must survive a reload.
export const useImiExportErrorsStore = create<State>((set) => ({
  errors: {},
  recordResult: (companyId, logs) => {
    if (!companyId || !logs) return
    let models: unknown
    try {
      const result = JSON.parse(logs)
      models = result?.Models ?? result?.models
    } catch {
      return
    }
    if (!Array.isArray(models)) return

    set((state) => {
      const errors = { ...state.errors[companyId] }
      for (const model of models) {
        const driver = model?.Driver ?? model?.driver
        const id = driver?.Id ?? driver?.id
        const status = model?.Status ?? model?.status
        if (
          (typeof id !== 'number' && typeof id !== 'string') ||
          typeof status !== 'boolean'
        )
          continue
        const message = model?.Message ?? model?.message
        if (status) {
          delete errors[String(id)]
        } else {
          errors[String(id)] =
            typeof message === 'string' && message ? message : 'IMI'
        }
      }
      return { errors: { ...state.errors, [companyId]: errors } }
    })
  },
  clearErrors: (companyId, driverIds) =>
    set((state) => {
      const errors = { ...state.errors[companyId] }
      driverIds.forEach((id) => delete errors[id])
      return { errors: { ...state.errors, [companyId]: errors } }
    }),
}))

const EMPTY_ERRORS: Record<string, string> = {}

export const useImiExportErrors = (companyId: string) =>
  useImiExportErrorsStore((state) => state.errors[companyId] ?? EMPTY_ERRORS)
